import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, message, Spin } from "antd";
import { useRecoilValue } from "recoil";
import cleanImage from "@/assets/images/cleanLibrary.png";
import hwordGroupImage from "@/assets/images/hwordGroup.svg";
import factoryManagement from "@/assets/images/factoryManagement.svg";
import beep from "@/assets/images/beep.svg";
import reportCentre from "@/assets/images/reportCentre.svg";
import operationMaintenance from "@/assets/images/operationMaintenance.svg";
import parameterFlowManagement from "@/assets/images/parameterFlowManagement.svg";
import otaManagement from "@/assets/images/otaManagement.svg";
import firmwareDevelopmentPlatform from "@/assets/images/firmwareDevelopmentPlatform.png";
import homeBgImage from "@/assets/images/home-bg.png";
import {
  tenantsInfo as recoilTenantsInfo,
  applicationPermissions as recoilApplicationPermissions,
} from "@/recoil";
import { envConfig } from "@/envConfig";
import { getLocale } from "@/gs-utils/core/storage/LocaleManager";
import "./app-home.less";

const { Meta } = Card;
const { homeUrl, serviceUrl } = envConfig;

// 模拟的配置数据和类型定义
const REGION = process.env.REACT_APP_REGION;
const cloud_locale = getLocale();
const assetsUrl =
  "https://gs-robot-static-resource.oss-cn-shanghai.aliyuncs.com/public/web/apps/assets";
// 模拟的SERVICES配置
const SERVICES = {
  beep: {
    key: "beep",
    param: "beep",
    title: "基础数据管理",
    image: beep,
    menuTitle: "基础数据管理",
    href: `${homeUrl}/beep`,
    description: "基础数据管理",
    descLocaleKey: "基础数据管理",
  },
  report: {
    key: "report",
    param: "report",
    title: "数据中心",
    image: reportCentre,
    menuTitle: "数据中心",
    href: `${homeUrl}/report-centre`,
    description: "从数据图表中获取信息",
    descLocaleKey: "从数据图表中获取信息",
  },
  iot: {
    key: "iot",
    param: "iot",
    title: "物联网平台",
    image: `${assetsUrl}/app-iot.svg`,
    menuTitle: "物联网平台",
    href: `${homeUrl}/iot`,
    description: "物联网平台",
    descLocaleKey: "物联网平台",
  },
  gsCloud: {
    key: "gsCloud",
    param: "gsCloud",
    title: "机器人平台",
    image: `${assetsUrl}/app-task.svg`,
    menuTitle: "机器人平台",
    href: `${serviceUrl}?locale=${cloud_locale}#/`,
    description: "机器人业务管理",
    descLocaleKey: "机器人业务管理",
  },
  console: {
    key: "console",
    param: "console",
    title: "IAM后台管理",
    image: `${assetsUrl}/app-console.svg`,
    menuTitle: "IAM后台管理",
    href: `${homeUrl}/tenant-center#/gas/tenant/manage`,
    description: "IAM后台管理",
    descLocaleKey: "IAM后台管理",
  },
  biManage: {
    key: "biManage",
    param: "biManage",
    title: "数据中心管理",
    image: `${assetsUrl}/app-report.svg`,
    menuTitle: "数据中心管理",
    href: `${homeUrl}/partner-report`,
    description: "数据中心后台配置",
    descLocaleKey: "数据中心后台配置",
  },
  cleanLibrary: {
    key: "cleanLibrary",
    param: "cleanLibrary",
    title: "标准工作项库",
    image: cleanImage,
    menuTitle: "标准工作项库",
    href: `${homeUrl}/clean-library`,
    description: "标准工作项库管理",
    descLocaleKey: "标准工作项库管理",
  },
  hwordGroup: {
    key: "hwordGroup",
    param: "hwordGroup",
    title: "华住注册",
    image: hwordGroupImage,
    menuTitle: "华住注册",
    href: `${homeUrl}/hword-group`,
    description: "华住注册",
    descLocaleKey: "华住注册",
  },
  factoryManagement: {
    key: "factoryManagement",
    param: "factoryManagement",
    title: "工厂信息管理",
    image: factoryManagement,
    menuTitle: "工厂信息管理",
    href: `${homeUrl}/factory-management`,
    description: "工厂信息管理",
    descLocaleKey: "工厂信息管理",
  },
  reportCentre: {
    key: "reportCentre",
    param: "reportCentre",
    title: "报表中心",
    image: reportCentre,
    menuTitle: "报表中心",
    href: `${homeUrl}/report-centre`,
    description: "报表中心",
    descLocaleKey: "报表中心",
  },
  operationMaintenance: {
    key: "operationMaintenance",
    param: "operationMaintenance",
    title: "运维运营",
    image: operationMaintenance,
    menuTitle: "运维运营",
    href: `${homeUrl}/operation-maintenance`,
    description: "运维运营",
    descLocaleKey: "运维运营",
  },
  parameterFlowManagement: {
    key: "parameterFlowManagement",
    param: "parameterFlowManagement",
    title: "机器分析与管控",
    image: parameterFlowManagement,
    menuTitle: "机器分析与管控",
    href: `${homeUrl}/parameter-flow-management`,
    description: "机器分析与管控",
    descLocaleKey: "机器分析与管控",
  },
  otaManagement: {
    key: "otaManagement",
    param: "otaManagement",
    title: "升级管理",
    image: otaManagement,
    menuTitle: "升级管理",
    href: `${homeUrl}/ota-management`,
    description: "升级管理",
    descLocaleKey: "升级管理",
  },
  equipmentImport: {
    key: "equipmentImport",
    param: "equipmentImport",
    title: "设备导入管理",
    image: cleanImage,
    menuTitle: "设备导入管理",
    href: `${homeUrl}/equipment-import`,
    description: "设备导入管理",
    descLocaleKey: "设备导入管理",
  },
  firmwareDevelopmentPlatform: {
    key: "firmwareDevelopmentPlatform",
    param: "firmwareDevelopmentPlatform",
    title: "版本研发平台",
    image: firmwareDevelopmentPlatform,
    menuTitle: "版本研发平台",
    href: `${homeUrl}/firmware-development-platform`,
    description: "版本研发平台",
    descLocaleKey: "版本研发平台",
  },
};

interface AppService {
  key: string;
  param: string;
  title: string;
  image: string;
  menuTitle: string;
  description: string;
  descLocaleKey: string;
  href: string;
}

/**
 * 高仙内部应用中心组件
 * 重构时间: 2025-10-14 17:41:17
 * 功能: 显示内部应用列表，根据用户权限控制访问
 */
const APPHome: React.FC = () => {
  const tenantsInfo = useRecoilValue(recoilTenantsInfo);
  const applicationPermissions = useRecoilValue(recoilApplicationPermissions);

  // 应用配置解构
  const {
    beep,
    report,
    iot,
    gsCloud,
    console,
    biManage,
    cleanLibrary,
    hwordGroup,
    factoryManagement,
    reportCentre,
    operationMaintenance,
    parameterFlowManagement,
    otaManagement,
    equipmentImport,
    firmwareDevelopmentPlatform,
  } = SERVICES;

  // 应用列表状态
  const [appsData, setAppsData] = useState<AppService[]>([]);

  // 样式配置
  const imgStyle: React.CSSProperties = {
    margin: "10px auto",
    width: "100%",
    height: "200px",
  };

  const defaultHeight: React.CSSProperties = {
    height: "380px",
    marginBottom: "1rem",
    borderRadius: "10px",
  };

  // 根据权限生成应用列表
  useEffect(() => {
    let _apps: AppService[] = [];

    // 海外版本显示特定应用
    if (REGION) {
      _apps = [parameterFlowManagement, otaManagement, iot];
    } else {
      // 内部用户显示完整应用列表
      if (tenantsInfo?.internalPerson) {
        _apps = [
          parameterFlowManagement,
          otaManagement,
          operationMaintenance,
          factoryManagement,
          firmwareDevelopmentPlatform,
          reportCentre,
          console,
          biManage,
          iot,
          beep,
          hwordGroup,
          cleanLibrary,
        ];
      }
    }

    setAppsData(_apps);
  }, [tenantsInfo?.internalPerson]);

  /**
   * 处理应用卡片跳转
   * @param app 应用配置对象
   * @param canJump 是否有权限跳转
   */
  const cardJump = (app: AppService, canJump: boolean): void => {
    if (canJump) {
      const { href } = app;
      window.location.href = href;
    } else {
      message.error("权限未开通，如需访问请联系管理员");
    }
  };

  /**
   * 处理应用点击事件
   * @param app 应用配置对象
   */
  const handleAppClick = (app: AppService): void => {
    switch (app.key) {
      case "console":
        cardJump(app, applicationPermissions?.includes("IAMBackendManagement"));
        break;

      case "gsCloud":
        {
          const { href } = gsCloud;
          window.location.href = href;
        }
        break;

      case "cleanLibrary":
        {
          const { href } = cleanLibrary;
          window.location.href = href;
        }
        break;

      case "report":
        {
          const { href } = report;
          window.location.href = href;
        }
        break;

      case "iot":
        cardJump(app, applicationPermissions?.includes("IoTPlatform"));
        break;

      case "biManage":
        cardJump(app, applicationPermissions?.includes("DataCenterManagement"));
        break;

      case "hwordGroup":
        cardJump(app, applicationPermissions?.includes("HwordGroupRegister"));
        break;

      case "factoryManagement":
        cardJump(
          app,
          applicationPermissions?.includes("FactoryInfoManagement")
        );
        break;

      case "beep":
        cardJump(
          app,
          applicationPermissions?.includes("DataCollectionPlatform")
        );
        break;

      case "reportCentre":
        cardJump(app, applicationPermissions?.includes("ReportCentre"));
        break;

      case "equipmentImport":
        {
          const { href } = equipmentImport;
          window.location.href = href;
        }
        break;

      case "operationMaintenance":
        cardJump(app, applicationPermissions?.includes("OM"));
        break;

      case "parameterFlowManagement":
        cardJump(app, applicationPermissions?.includes("PTM"));
        break;

      case "otaManagement":
        cardJump(app, applicationPermissions?.includes("UpgradeManagement"));
        break;

      case "firmwareDevelopmentPlatform":
        cardJump(
          app,
          applicationPermissions?.includes("FirmwareDevelopmentPlatform")
        );
        break;

      default:
        break;
    }
  };

  return (
    <div
      className="app-home-wrapper"
      style={{
        gridTemplateColumns: "1fr",
      }}
    >
      {/* 头部背景区域 */}
      <div
        className="app-home-bg"
        style={{
          backgroundImage: `url(${homeBgImage})`,
        }}
      >
        <div>{"高仙内部应用"}</div>
        <div>
          您已进入公司内网，为保障信息安全，请勿随意分享页面或截图，感谢配合！
        </div>
      </div>

      {/* 应用列表区域 */}
      <Spin spinning={!tenantsInfo?.internalPerson}>
        <div className="app-home-right">
          {appsData.map((app) => {
            // 应用标题国际化处理
            const _title = app.title;
            // 应用描述国际化处理
            const _desc = app.description;

            return (
              <Card
                key={app.key}
                title={_title}
                hoverable
                cover={<img alt={_title} src={app.image} style={imgStyle} />}
                style={defaultHeight}
                onClick={() => handleAppClick(app)}
              >
                <Meta title={"应用描述"} description={_desc} />
              </Card>
            );
          })}
        </div>
      </Spin>
    </div>
  );
};

export default APPHome;
